import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  input,
  model,
  signal,
} from '@angular/core';
import { generateId } from '@odilo/ui-components';

@Component({
  selector: 'nr-theme-selector',
  templateUrl: './theme-selector.html',
  styleUrl: './theme-selector.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ThemeSelectorComponent {
  protected readonly id = signal(generateId()).asReadonly();
  protected readonly labelId = generateId('theme-label-');

  readonly label = input.required<string>();
  readonly value = model<string>();
}
